module.exports = __webpack_public_path__ + "img/facebook.927e6ecc.png";